import { reaction } from 'mobx';
import { ZipApi } from '../../lib/ZipApi';
import { directoryStore } from '../DirectoryStore';
import { ObjectDefinition, Target } from '../../types/DataSyncItem';
import { DataSyncObjectsStore } from './DataSyncObjectsStore';

export default class DataSyncOdpObjectsStore extends DataSyncObjectsStore {
  public constructor(target: Target) {
    super(target);
    reaction(() => directoryStore.isReady, (ready) => {
      if (ready) {
        this.fetch();
      }
    }, {fireImmediately: true});
  }

  public setInstanceId(): void {
    // No-op for ODP objects
  }

  protected async fetchSourceObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId) {
      return [];
    }

    const objectDefinitions = await ZipApi.listODPSchemas(directoryStore.trackerId);
    return objectDefinitions.sort((a, b) =>
      a.object_display_name.localeCompare(b.object_display_name));
  }

  protected async fetchDestinationObjectDefinitions(): Promise<ObjectDefinition[]> {
    throw new Error('Hub destination is not supported');
  }

  protected canFetch(): boolean {
    return !!directoryStore.trackerId;
  }
}
